import React from 'react';
import {Modal, Text} from '@forecast-it/design-system';

export interface DeleteCohortModalProps {
	cohortName: string;
	memberCount: number;
	onConfirm: () => void;
	onClose: () => void;
}

/**
 * Confirms a cohort delete before the mutation fires. Rendered directly by `CohortsTab`, the way
 * `FeatureFlagRolloutModal` is rendered directly by `FeatureFlagDetail` — this is internal tooling, not
 * the customer-facing surface the generic modal conductor is for.
 */
export function DeleteCohortModal({cohortName, memberCount, onConfirm, onClose}: DeleteCohortModalProps): JSX.Element {
	const countLabel = memberCount === 1 ? '1 company' : `${memberCount} companies`;

	return (
		<Modal onCloseModal={onClose} size={Modal.SIZE.SMALL}>
			<Modal.Title>Delete cohort</Modal.Title>
			<Modal.Content>
				<Text>
					{`Delete '${cohortName}'? It holds ${countLabel}. Deleting the cohort does not change any flag a company already has.`}
				</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton dataCy="cohort-delete-confirm" onPress={onConfirm}>
					Delete cohort
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton dataCy="cohort-delete-cancel" onPress={onClose}>
					Cancel
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
}
